import { Link } from 'react-router-dom';
import type { Drama } from '@/mocks/dramas';

interface DramaCardProps {
  drama: Drama;
}

export default function DramaCard({ drama }: DramaCardProps) {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Link
      to={`/drama/${drama.id}`}
      onClick={handleClick}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={drama.image}
          alt={drama.title}
          title={`${drama.title} - 香蕉影视高清在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-2 left-2 flex gap-1 flex-wrap">
          {drama.isHot && (
            <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-primary-500 text-white whitespace-nowrap">
              热播
            </span>
          )}
          {drama.isNew && (
            <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-accent-500 text-white whitespace-nowrap">
              新剧
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 text-xs font-bold rounded bg-black/60 text-accent-300 whitespace-nowrap">
            {drama.rating}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-3 pt-8">
          <p className="text-xs text-white/80">{drama.updateInfo}</p>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
          {drama.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
          <span>{drama.region}</span>
          <span className="text-foreground-300">·</span>
          <span>{drama.year}</span>
          <span className="text-foreground-300">·</span>
          <span className="text-primary-500">{drama.status}</span>
        </div>
        <div className="flex flex-wrap gap-1 mt-2">
          {drama.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-1.5 py-0.5 text-xs rounded bg-secondary-100 text-secondary-700 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}